var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.skipShow)?_c('Box',[(_vm.loading)?_c('Loader'):_c('ServiceForm')],1):_c(_vm.skipComponent,{tag:"component",on:{"toggle":_vm.toggleSkip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }